import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterlist'
})
export class FilterlistPipe implements PipeTransform {
public searchTxtCatch = ""
  transform(data: Array<any>, searchTxt: string): Array<any> {
    /* this filter returns list that contains searchTxt */

    // let filterdData = data.filter((value:any, index:number) =>{
    //   if(value.name.toUpperCase().indexOf(searchTxt.toUpperCase()) > -1 ) {
    //     return data[index];
    //   }
    // })

    /* this filter returns list that starts with searchTxt */
    var filterdData = [];
    
    // debugger
    if (searchTxt && searchTxt.length  && searchTxt.length >= 3) {
      this.searchTxtCatch = searchTxt;
      filterdData = data.filter((value:any, index:number) =>{
        if(value.name.toUpperCase().startsWith(searchTxt.toUpperCase())) {
          return data[index];
        }
      });
    }else if(searchTxt.length < 3 && searchTxt.length > 0 && this.searchTxtCatch.length > 0){
      this.searchTxtCatch = searchTxt;
      filterdData = data.filter((value:any, index:number) =>{
        if(value.name.toUpperCase().startsWith(this.searchTxtCatch.toUpperCase())) {
          return data[index];
        }
      });
    }else{
      this.searchTxtCatch = "";
      filterdData = [];
    }

    if (filterdData && filterdData.length > 0) {
      return filterdData;
    }else if(searchTxt.length < 3){
      return [];
      // return [{"name":"Type to search", "id":-2}];
    }else{
      return [{"name":"Not Found", "id":-1}];
    }
  }

}
